import React, { useCallback } from "react";
import {
  Box,
  Container,
  Link,
  Paper,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { LoginForm, LoginFormData } from "./LoginForm";
import { useLogin } from "../../hooks/useLogin";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useNotify } from "../../hooks/system/useNotify";

export const FullScreenBox = styled(Box)((p) => ({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  [p.theme.breakpoints.down("sm")]: {
    alignItems: "stretch",
  },
}));

export const LoginPaper = styled(Paper)((p) => ({
  display: "flex",
  minWidth: p.theme.breakpoints.values['sm'],
  flexDirection: "column",
  justifyContent: "center",
  [p.theme.breakpoints.down("sm")]: {
    flexGrow: 1,
  },
}));

const BoxCenter = styled(Box)((p) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
}));

export const LoginPage = () => {
  const theme = useTheme(),
    isMobile = useMediaQuery(theme.breakpoints.down("sm")),
    { current, addNotify } = useNotify(),
    { login } = useLogin();

  const onSubmit = useCallback(
    async (date: LoginFormData) => {
      login(date.email, date.password)
        .then(() => addNotify("success", "Login success"))
        .catch((e) => {
          if (e.status === 404) {
            addNotify("warning", "User not found with this email address")
          } else {
            addNotify("error", "Login error", e.message)
          }
        });
    },
    [addNotify, login]
  );

  return (
    <>
      <Container maxWidth="md" disableGutters={isMobile}>
        <FullScreenBox width={isMobile ? "100%" : "auto"}>
          <LoginPaper elevation={isMobile ? 0 : 3} square={isMobile}>
            {current && (
              <Alert severity={current.variant}>
                <AlertTitle>
                  <b>{current.title}</b>
                </AlertTitle>
                {current.message}
              </Alert>
            )}
            <Box
              p={3}
              flexGrow={1}
              justifyContent="center"
              flexDirection="column"
              display="flex"
            >
              <Typography variant="subtitle2">Login to your account</Typography>
              <LoginForm onSubmit={onSubmit} />
              <BoxCenter mt={1}>
                <Link href="/reset-password">Password reset</Link>
              </BoxCenter>
            </Box>
          </LoginPaper>
        </FullScreenBox>
      </Container>
    </>
  );
};
